import(/* webpackMode: "eager" */ "/vercel/path0/src/app/reviewty/page.tsx");
